import { Injectable      } from '@angular/core';
import { UtilsManager    } from 'src/app/managers/utils/utils.manager';
import { NotifierManager } from 'src/app/managers/notifier/notifier.manager';
import { Notifier        } from 'src/app/enums/notifier/notifier.enum';
import { NotifierMessage } from 'src/app/enums/notifier/message/notifier.enum';
import { RequestManager  } from 'src/app/managers/request/request.manager';
import { ErrorManager    } from 'src/app/managers/error/error.manager';
import { GuidedCreation } from 'src/app/beans/guided-creation/guided.creation.bean';
import { GuidedCreation2 } from 'src/app/beans/guidedCreation2/guidedCreation2';

@Injectable
({
  providedIn: 'root'
})

export class HubHandler
{
    constructor
    (
      private _utils    : UtilsManager    ,
      private _notifier : NotifierManager ,
      private _request  : RequestManager  ,
      private _error    : ErrorManager    ,
    ) {}

    async list( token: string )
    {      
        if (!this._utils.checker().isValidText( token )) 
        {
          this._notifier.show( 
            Notifier.WARNING                , 
            NotifierMessage.INVALID_PASSWORD,
          )
          return undefined
        }

        try
        {
          const response = await this._request.hub().list( token ).toPromise()

          if (this._error.hasError( response )){
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response )
          }

          return response

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async createComplete(token: string, data: GuidedCreation2, orgId?: number) 
    {
        if(!this._utils.checker().isValidText(token)) 
        {
          this._notifier.show( 
            Notifier.WARNING                 , 
            NotifierMessage.TOKEN_HAS_EXPIRED,
          )
          return undefined
        }

        try
        {
          const response = await this._request.hub().createComplete(token, JSON.stringify(data), orgId).toPromise()

          if(this._error.hasError( response ))
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp(response)
          }
          else
          {
            this._notifier.show
            ( 
              Notifier.SUCCESS            , 
              NotifierMessage.OPERATION_OK,
            )

            return response
          }

          return response
        }
        catch( error )
        { // this._error.handleNetwork ( error )  
          return undefined
        }
    }
}

